import React from "react";
import { Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const TooltipInfo = ({ message, tooltipText }) => {
  return (
    <Container>
      <h5>
        {message}
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id="info-tooltip" className="text-start">
              {tooltipText}
            </Tooltip>
          }
        >
          <span style={{ cursor: "pointer", marginLeft: "5px" }}>
            <FontAwesomeIcon icon={faInfoCircle} className="text-primary" style={{ fontSize: "16px" }} />
          </span>
        </OverlayTrigger>
      </h5>
    </Container>
  );
};

export default TooltipInfo;
